module.exports = __webpack_public_path__ + "YellowStrategy.a532fda.png";